import formSubmit from "../util/formSubmit";

export default {
  init() {},
  finalize() {
    const $modal = $("#modalEventSubscribe");
    const $form = $("#subscribe-event-form");
    const $submitButton = $form.find(":submit");
    const $originalFormBody = $form.find(".modal-form-content");
    const $successFormBody = $form.find(".modal-form-success");
    const $failFormBody = $form.find(".alert-danger");

    const $formValidate = formSubmit("#subscribe-event-form");

    $modal.on("hidden.bs.modal", function () {
      $form[0].reset();
      $formValidate.resetForm();
      $form.find(".invalid").removeClass("invalid");
      $originalFormBody.removeClass("d-none");
      $successFormBody.addClass("d-none");
      $submitButton.removeClass("d-none");
      $failFormBody.addClass("d-none").text("");
    });

    $(".event__gallery")
      .not(".slick-initialized")
      .slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        lazyLoad: "ondemand",
        prevArrow:
          '<a href="#" class="event__gallery__arrow event__gallery__arrow-left"><i class="fa-regular fa-arrow-left"></i></a>',
        nextArrow:
          '<a href="#" class="event__gallery__arrow event__gallery__arrow-right"><i class="fa-regular fa-arrow-right"></i></a>',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
  },
};
